import { useMemo } from 'react'

export const useEffectiveSource = (
  source: string | null,
  platform: string | null = null,
  userAgent: string | null = null,
  provider: string | null = null,
): string | null | undefined => {
  return useMemo(() => {
    if (source === 'voice-memo') {
      if (platform) {
        return 'voice-memo-desktop'
      } else if (userAgent) {
        return 'voice-memo-mobile'
      }
    }

    if (source === 'phone' && provider !== null) {
      return `phone-${provider}`
    }
    return source
  }, [source, platform, userAgent, provider])
}
